import React from 'react';
import styled from '@emotion/styled';
import DatasetHit from 'types/DatasetHit';
import { Typography } from '@mui/material';
import Link from 'components/core/Link';

const Wrapper = styled.a`
    width: 100%;
    border-bottom: solid 1px #6a7282;
    display: flex;
    flex-direction: column;
    padding-inline: 0.5rem;
    padding-block: 2rem;
    color: inherit;
    text-decoration: none;
    &:hover {
        background-color: oklch(0.623 0.214 259.815 / .1);
    }
`;

const LineClamped = styled(Typography)`
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
`;

const Hit = ({ hit }: { hit: DatasetHit}): React.ReactElement => {

    return (
        <Wrapper
            target="_blank"
            href={hit.links.latest_html}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '1rem',
                    marginBottom: '0.5rem',
                }}
            >
                <div
                    style={{
                        paddingBlock: '0.25rem',
                        paddingInline: '0.5rem',
                        backgroundColor: 'oklch(0.623 0.214 259.815)',
                        fontWeight: 'bold',
                        fontSize: '0.75rem',
                        borderRadius: '0.25rem',
                        color: 'white',
                    }}
                >
                    {hit.ui.updated_date_l10n_long} ({hit.ui.version})
                </div>
                <div
                    style={{
                        paddingInline: '0.5rem',
                        paddingBlock: '0.25rem',
                        color: 'white',
                        backgroundColor: '#6a7282',
                        fontWeight: 'bold',
                        fontSize: '0.75rem',
                        borderRadius: '0.25rem',
                    }}
                >
                    {hit.ui.resource_type.title_l10n}
                </div>
                <div
                    style={{
                        paddingInline: '0.5rem',
                        paddingBlock: '0.25rem',
                        color: 'white',
                        backgroundColor: 'oklch(0.627 0.194 149.214)',
                        fontWeight: 'bold',
                        fontSize: '0.75rem',
                        borderRadius: '0.25rem',
                    }}
                >
                    {hit.ui.access_status.title_l10n}
                </div>
            </div>
            <Link>
                <Typography
                    variant="h5"
                    style={{textAlign: 'start'}}
                >
                    {hit.metadata.title}
                </Typography>
            </Link>
            <Typography
                variant="body2"
                style={{
                    color: '#6a7282',
                }}
            >
                {hit.ui.creators?.creators?.reduce((p: string, c) => `${p}${p ? ', ' : ''}${c.person_or_org.name}`, '')}
            </Typography>
            <LineClamped
                variant="body1"
                style={{
                    margin: '0.5rem 0 0.5rem 0',
                }}
            >
                {hit.ui.description_stripped}
            </LineClamped>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: '0.5rem',
                    marginInline: '0',
                    marginBlock: '0.5rem',
                }}
            >
                {[...hit.metadata.msdlive_projects?.map((t)=>t.name) ?? []].map((tag, i) => (
                    <div
                        key={i}
                        style={{
                            paddingInline: '0.5rem',
                            paddingBlock: '0.25rem',
                            color: '#364153',
                            backgroundColor: '#d1d5dc',
                            fontWeight: 'bold',
                            fontSize: '0.75rem',
                            borderRadius: '0.25rem',
                        }}
                    >
                        {tag}
                    </div>
                ))}
                {[...hit.metadata.msdlive_science_themes?.map((t)=>t.science_theme) ?? []].map((tag, i) => (
                    <div
                        key={i + (hit.metadata.msdlive_projects?.length ?? 0)}
                        style={{
                            paddingInline: '0.5rem',
                            paddingBlock: '0.25rem',
                            color: '#364153',
                            backgroundColor: '#d1d5dc',
                            fontWeight: 'bold',
                            fontSize: '0.75rem',
                            borderRadius: '0.25rem',
                        }}
                    >
                        {tag}
                    </div>
                ))}
            </div>
            <Typography variant='body2'
                style={{
                    color: '#6a7282',
                }}
            >
                Uploaded on {hit.ui.created_date_l10n_long}
            </Typography>
        </Wrapper>
    );

}



export default Hit;
